/**
 * @generated SignedSource<<797f50f98112e2ccb48be6a51030c438>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastAckFocusType = "RECEIVED" | "RENDERED";
export type FocusTVAckMutation$variables = {
  sessionId: string;
  type: StorecastAckFocusType;
};
export type FocusTVAckMutation$data = {
  readonly ackFocus: boolean | null;
};
export type FocusTVAckMutation = {
  response: FocusTVAckMutation$data;
  variables: FocusTVAckMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "kind": "ScalarField",
    "name": "ackFocus",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FocusTVAckMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FocusTVAckMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "814e9d758dc636f440de066f251a5983",
    "id": null,
    "metadata": {},
    "name": "FocusTVAckMutation",
    "operationKind": "mutation",
    "text": "mutation FocusTVAckMutation(\n  $sessionId: ID!\n  $type: StorecastAckFocusType!\n) {\n  ackFocus(sessionId: $sessionId, type: $type)\n}\n"
  }
};
})();

(node as any).hash = "984679094e3c0f63b9450108efc45105";

export default node;
